import React from "react";
import { EnvironmentConfig } from "@me8eon/config";
import { EonUiWebsiteNavigationColumn, EonUiWebsiteNavigationLogo, EonUiWebsiteNavigationMain } from "@eon-ui/eon-ui-components-react";
import "./header.scss";
import { AuthComponent } from "../auth/AuthComponent";
import LanguageSwitch from "../language-switch/LanguageSwitch";
import { useCombinedStore } from "../../store/headerStore";
import { useTheme } from "@me8eon/themes";
import bayernwerk from "../../assets/image/header-logos/bayernwerk.raw.svg";
import eon from "../../assets/image/header-logos/eon.raw.svg";
import myhelpbayern from "../../assets/image/header-logos/myhelp-bayern.raw.svg";
import myhelp from "../../assets/image/header-logos/myhelp.raw.svg";
import myhelpNew from "../../assets/image/header-logos/myhelp-new.raw.svg";
import { setActiveRoleIndex } from "@me8eon/msal_authentication";
import { useUserData } from "@me8eon/react_authentication";
import { GenericDropdown } from "@me8eon/generic_dropdown";
import { useTranslation } from "@me8eon/translation";
import { PublicClientApplication } from "@azure/msal-browser";
import { DevModeState, useDevModeState } from "@me8eon/devmode";
import { Icon } from "@me8eon/icons";
import { useNavigate } from "react-router-dom";
import StarBadge from "./StarBadge";
import { ROLE_PRODUCT_TEAM_DASHBOARD } from "../../pages/product-owner-dashboard/ProductOwnerDashboard.constants";
import { ROLE_AIDWOPS_DASHBOARD } from "../../pages/aidwops/expert-dashboard/ExpertDashboard.constants";

type HeaderProps = {
    orgName: string;
    msalInstance: PublicClientApplication;
    sidebarOpen?: boolean;
    onToggleSidebar?: () => void;
}
const Header = ({ orgName, msalInstance, sidebarOpen = false, onToggleSidebar }: HeaderProps) => {
    const { language, setLanguage, favData } = useCombinedStore();
    const t = useTranslation();

    console.log({ orgName, language, setLanguage, favData });
    const theme = useTheme();
    const userData = useUserData();
    const { loggedIn, featureFlagEnabled, actualRoles = [] } = userData;
    const aiRoute = featureFlagEnabled ? "/new-ai" : "/ai";
    const navigate = useNavigate();
    const { value: themeName, header } = theme;
    const { meAtEonLogoUrl, eonLogoUrl } = header;
    const [devMode, setDevMode] = useDevModeState();

    function toggleDevMode() {
        setDevMode(old => old?.selected ? {} as DevModeState : { selected: "hide" });
    }

    const imageMap: any = {
        bayernwerk,
        eon,
        me8bayern: myhelpbayern,
        me8eon: featureFlagEnabled ? myhelpNew : myhelp,
        default_eon: eon,
        default_me8eon: myhelp,
    };

    const roleToggle = (selectedValue: string) => {
        // const index = userData.allRoles.findIndex((role) => role === selectedValue);
        //This uses msal. Even in teams! but in teams this isn't an idea that exists, and I think this will still work as it will have no effect and won't crash
        setActiveRoleIndex(msalInstance, selectedValue);
        window.location.href = EnvironmentConfig.featureEnabledForUser.includes(selectedValue) ? "/new-ai" : "/ai";
    };

    const admin = localStorage.getItem("admin") === "true";

    const navigationButtonGroup = (
        <>
            <button className="nav-button" onClick={() => navigate(aiRoute, { state: { startNewChat: true } })}>
                Ask MyHelp
            </button>
            <button className="nav-button" onClick={() => navigate("/tile")}>
                Dashboard
            </button>
            {actualRoles.includes(ROLE_PRODUCT_TEAM_DASHBOARD) && (
                <button className="nav-button" onClick={() => navigate("/analytics")}>
                    Analytics
                </button>
            )}
            {actualRoles.includes(ROLE_AIDWOPS_DASHBOARD) && (
                <button className="nav-button" onClick={() => navigate("/aidwops")}>
                    AIDWOPS
                </button>
            )}
        </>
    );
    return (
        <EonUiWebsiteNavigationMain
            slot="main"
            className={`me-eon-header ${featureFlagEnabled ? "me-eon-header--beta" : ""}`}
            data-testid="header"
        >

            <EonUiWebsiteNavigationColumn content-alignment="left" className="header-brand">
                <div className="header-brand-content">
                {featureFlagEnabled && loggedIn && (
                    <button
                        type="button"
                        className="mobile-sidebar-toggle"
                        onClick={onToggleSidebar}
                        aria-expanded={sidebarOpen}
                        aria-controls="beta-left-sidebar"
                        aria-label={sidebarOpen ? t("chatBot.close") : t("chatBot.open")}
                    >
                        <Icon name={sidebarOpen ? "close" : "menu"} size="small" />
                    </button>
                )}
                <EonUiWebsiteNavigationLogo
                    imageSrc={imageMap[meAtEonLogoUrl] || imageMap.default_me8eon}
                    description="MyHelp"
                    onClick={(e) => {
                        e.preventDefault();
                        if (window.location.pathname === aiRoute) {
                            navigate(aiRoute, { state: { startNewChat: true } });
                        } else {
                            navigate(aiRoute, { state: { startNewChat: true } });
                        }
                    }}
                    href="#"
                    className="main-logo"
                ></EonUiWebsiteNavigationLogo>
                {featureFlagEnabled && (
                    <div className="desktop-only" id="newAiTourNavigation">
                        {navigationButtonGroup}
                    </div>
                )}
                </div>
            </EonUiWebsiteNavigationColumn>
            <EonUiWebsiteNavigationColumn content-alignment="right">
                {loggedIn && (
                    <button
                        className="auth-wrapper"
                        onClick={() => navigate(`/about-myhelp?tab=2`)}
                        title={t("whatsnewtt")}
                    >
                        {!featureFlagEnabled && <StarBadge text={t("new")} textColor="#fff" size={32} />}
                        <span className="username whatsnew-text">
                            {featureFlagEnabled ? t("whatsnew") : <b>{t("whatsnew")}</b>}
                        </span>
                    </button>
                )}
                <AuthComponent />
                {userData.allRoles.length > 1 && (
                    <GenericDropdown
                        label={t("switchRole")}
                        icon="change_contract_01"
                        rootId="roles-dropdown"
                        options={userData.allRoles}
                        maxWidth="200px"
                        selectedOps={userData.currentRole}
                        clickHandler={roleToggle}
                    />
                )}
                <LanguageSwitch />
                {admin && loggedIn && <button style={{ border: 0 }} onClick={toggleDevMode}>Dev</button>}

                <div className="eon-logo-wrapper">
                    <EonUiWebsiteNavigationLogo
                        imageSrc={imageMap[eonLogoUrl] || imageMap.eon}
                        description="E.ON Logo"
                    ></EonUiWebsiteNavigationLogo>
                </div>
            </EonUiWebsiteNavigationColumn>
        </EonUiWebsiteNavigationMain>
    );
};
export default Header;
